/* eslint-disable react-refresh/only-export-components --
   This file exports both the LanguageProvider component and the useLanguage hook. */
import React, { createContext, useContext, useState, ReactNode } from "react";

type Language = "en" | "hi";

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const translations = {
  en: {
    welcome: "Welcome to Vidyapeeth",
    studentLogin: "Student Login",
    teacherLogin: "Teacher Login",
    email: "Email",
    password: "Password",
    signUp: "SignUp",
    login: "Login",
    orSignUpWith: "Or SignUp with",
    google: "Google",
    required: "This field is required",
    invalidEmail: "Invalid email address",
    passwordMin: "Password must be at least 6 characters",
    signUpSuccess: "Sign up successful! Please check your email.",
    signUpError: "Sign up failed. Please try again.",
    loginError: "Login failed. Please check your credentials.",
  },
  hi: {
    welcome: "Vidyapeeth में आपका स्वागत है",
    studentLogin: "छात्र लॉगिन",
    teacherLogin: "शिक्षक लॉगिन",
    email: "ईमेल",
    password: "पासवर्ड",
    signUp: "साइन अप करें",
    login: "लॉग इन करें",
    orSignUpWith: "या साइन अप करें",
    google: "गूगल",
    required: "यह फील्ड आवश्यक है",
    invalidEmail: "अमान्य ईमेल पता",
    passwordMin: "पासवर्ड कम से कम 6 अक्षर का होना चाहिए",
    signUpSuccess: "साइन अप सफल! कृपया अपना ईमेल जांचें।",
    signUpError: "साइन अप विफल। कृपया पुनः प्रयास करें।",
    loginError: "लॉगिन विफल। कृपया अपनी साख जांचें।",
  },
};

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined,
);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [language, setLanguage] = useState<Language>("en");

  const t = (key: string): string => {
    return translations[language][key as keyof typeof translations.en] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
